import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { NormalizeImagePipe } from '../../../shared/pipes/normalize-image.pipe';

@Component({
  selector: 'mob-offer-card',
  templateUrl: './offer-card.componet.html',
  styleUrls: ['./offer-card-componet.scss'],
})
export class OfferCardComponent {
  @Input() VO: any;
  @Input() isMock: boolean;
  @Input() form: FormGroup;
  @Input() cpf: AbstractControl;
  @Input() formSubmitted: boolean;
  @Output() startCmcFlow = new EventEmitter();
  @Output() sendTag = new EventEmitter();

  public normalizeImage = NormalizeImagePipe.prototype.transform;

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (event.target.localName == 'a') {
      this.sendTag.emit(event);
    }
  }

  send(event: any) {
    this.startCmcFlow.emit(event);
  }
}
